import { authHeader } from '@/_helpers';

export const regionsService = {
    getAll,
    getHierarchy,
    getCountries,
    getTimezones
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };

    return fetch(`${apiUrl}/regions/`, requestOptions).then(handleResponse);
}

function getHierarchy() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/regions/hierarchy`, requestOptions).then(handleResponse);
}


function getCountries() {

    let countries = [
            {
                "id": "France",
                "label": "France"
            },
            {
                "id": "Belgium",
                "label": "Belgium"
            },
            {
                "id": "Czechia",
                "label": "Czechia"
            },
            {
                "id": "United States",
                "label": "United States"
            },
            {
                "id": "Canada",
                "label": "Canada"
            },
            {
                "id": "United Kingdom",
                "label": "United Kingdom"
            },
            {
                "id": "Belarus",
                "label": "Belarus"
            },
            {
                "id": "Philippines",
                "label": "Philippines"
            },
            {
                "id": "Palestine",
                "label": "Palestine"
            },
            {
                "id": "Luxembourg",
                "label": "Luxembourg"
            },
            {
                "id": "Switzerland",
                "label": "Switzerland"
            },
            {
                "id": "Italy",
                "label": "Italy"
            },
            {
                "id": "Mexico",
                "label": "Mexico"
            },
            {
                "id": "Germany",
                "label": "Germany"
            },
            {
                "id": "Morocco",
                "label": "Morocco"
            },
            {
                "id": "United Arab Emirates",
                "label": "United Arab Emirates"
            },
            {
                "id": "Netherlands",
                "label": "Netherlands"
            },
            {
                "id": "Spain",
                "label": "Spain"
            },
            {
                "id": "Senegal",
                "label": "Senegal"
            },
            {
                "id": "India",
                "label": "India"
            },
            {
                "id": "Hong Kong",
                "label": "Hong Kong"
            },
            {
                "id": "Côte d'Ivoire",
                "label": "Côte d'Ivoire"
            },
            {
                "id": "Turkey",
                "label": "Turkey"
            },
            {
                "id": "Argentina",
                "label": "Argentina"
            },
            {
                "id": "Thailand",
                "label": "Thailand"
            },
            {
                "id": "Finland",
                "label": "Finland"
            },
            {
                "id": "Egypt",
                "label": "Egypt"
            },
            {
                "id": "Taiwan",
                "label": "Taiwan"
            },
            {
                "id": "Cameroon",
                "label": "Cameroon"
            },
            {
                "id": "China",
                "label": "China"
            },
            {
                "id": "Brazil",
                "label": "Brazil"
            },
            {
                "id": "Australia",
                "label": "Australia"
            },
            {
                "id": "Russia",
                "label": "Russia"
            },
            {
                "id": "Lithuania",
                "label": "Lithuania"
            },
            {
                "id": "Jersey",
                "label": "Jersey"
            },
            {
                "id": "South Africa",
                "label": "South Africa"
            },
            {
                "id": "Guadeloupe",
                "label": "Guadeloupe"
            },
            {
                "id": "Singapore",
                "label": "Singapore"
            },
            {
                "id": "New Caledo",
                "label": "New Caledo"
            },
            {
                "id": "French Guinea",
                "label": "French Guinea"
            },
            {
                "id": "Tunisia",
                "label": "Tunisia"
            },
            {
                "id": "Sweden",
                "label": "Sweden"
            },
            {
                "id": "Netherland",
                "label": "Netherland"
            },
            {
                "id": "Norway",
                "label": "Norway"
            },
            {
                "id": "Malta",
                "label": "Malta"
            },
            {
                "id": "Ireland",
                "label": "Ireland"
            },
            {
                "id": "Japan",
                "label": "Japan"
            },
            {
                "id": "Lebanon",
                "label": "Lebanon"
            },
            {
                "id": "Poland",
                "label": "Poland"
            },
            {
                "id": "Denmark",
                "label": "Denmark"
            },
            {
                "id": "Gabon",
                "label": "Gabon"
            },
            {
                "id": "Malaysia",
                "label": "Malaysia"
            },
            {
                "id": "Tanzania",
                "label": "Tanzania"
            },
            {
                "id": "Bahrain",
                "label": "Bahrain"
            },
            {
                "id": "Algeria",
                "label": "Algeria"
            },
            {
                "id": "Chile",
                "label": "Chile"
            },
            {
                "id": "Uruguay",
                "label": "Uruguay"
            },
            {
                "id": "Mauritania",
                "label": "Mauritania"
            },
            {
                "id": "Ghana",
                "label": "Ghana"
            },
            {
                "id": "Guinea",
                "label": "Guinea"
            },
            {
                "id": "Indonesia",
                "label": "Indonesia"
            },
            {
                "id": "Reunion",
                "label": "Reunion"
            },
            {
                "id": "South Kore",
                "label": "South Kore"
            },
            {
                "id": "Moldova",
                "label": "Moldova"
            },
            {
                "id": "Kazakhstan",
                "label": "Kazakhstan"
            },
            {
                "id": "Slovenia",
                "label": "Slovenia"
            },
            {
                "id": "Kosovo",
                "label": "Kosovo"
            },
            {
                "id": "Guatemala",
                "label": "Guatemala"
            },
            {
                "id": "Philippine",
                "label": "Philippine"
            },
            {
                "id": "Madagascar",
                "label": "Madagascar"
            },
            {
                "id": "Israel",
                "label": "Israel"
            },
            {
                "id": "Portugal",
                "label": "Portugal"
            },
            {
                "id": "Colombia",
                "label": "Colombia"
            },
            {
                "id": "Vietnam",
                "label": "Vietnam"
            },
            {
                "id": "Ukraine",
                "label": "Ukraine"
            },
            {
                "id": "Nigeria",
                "label": "Nigeria"
            },
            {
                "id": "Democratic Republic Of Kongo",
                "label": "Democratic Republic Of Kongo"
            },
            {
                "id": "Costa Rica",
                "label": "Costa Rica"
            },
            {
                "id": "Hungary",
                "label": "Hungary"
            },
            {
                "id": "Kuwait",
                "label": "Kuwait"
            },
            {
                "id": "Kenya",
                "label": "Kenya"
            },
            {
                "id": "Sri Lanka",
                "label": "Sri Lanka"
            },
            {
                "id": "Greece",
                "label": "Greece"
            },
            {
                "id": "Niger",
                "label": "Niger"
            },
            {
                "id": "Syria",
                "label": "Syria"
            },
            {
                "id": "Bulgaria",
                "label": "Bulgaria"
            },
            {
                "id": "Pakistan",
                "label": "Pakistan"
            },
            {
                "id": "Saudi Arabia",
                "label": "Saudi Arabia"
            },
            {
                "id": "Albania",
                "label": "Albania"
            },
            {
                "id": "Croatia",
                "label": "Croatia"
            },
            {
                "id": "French Polynesia",
                "label": "French Polynesia"
            },
            {
                "id": "Monaco",
                "label": "Monaco"
            },
            {
                "id": "Mauritius",
                "label": "Mauritius"
            },
            {
                "id": "Romania",
                "label": "Romania"
            },
            {
                "id": "Republic o",
                "label": "Republic o"
            },
            {
                "id": "Qatar",
                "label": "Qatar"
            },
            {
                "id": "Ecuador",
                "label": "Ecuador"
            },
            {
                "id": "Czech Republic",
                "label": "Czech Republic"
            },
            {
                "id": "Austria",
                "label": "Austria"
            },
            {
                "id": "Cyprus",
                "label": "Cyprus"
            },
            {
                "id": "Iraq",
                "label": "Iraq"
            },
            {
                "id": "Central Afric",
                "label": "Central Afric"
            },
            {
                "id": "Benin",
                "label": "Benin"
            },
            {
                "id": "Latvia",
                "label": "Latvia"
            },
            {
                "id": "Uganda",
                "label": "Uganda"
            },
            {
                "id": "Iran",
                "label": "Iran"
            },
            {
                "id": "Suriname",
                "label": "Suriname"
            },
            {
                "id": "Peru",
                "label": "Peru"
            },
            {
                "id": "Congo",
                "label": "Congo"
            },
            {
                "id": "New Zealand",
                "label": "New Zealand"
            },
            {
                "id": "Saint Pierre Miquelon",
                "label": "Saint Pierre Miquelon"
            },
            {
                "id": "Djibouti",
                "label": "Djibouti"
            },
            {
                "id": "Martinique",
                "label": "Martinique"
            },
            {
                "id": "Trinidad a",
                "label": "Trinidad a"
            },
            {
                "id": "Chad",
                "label": "Chad"
            },
            {
                "id": "Serbia",
                "label": "Serbia"
            },
            {
                "id": "Bangladesh",
                "label": "Bangladesh"
            },
            {
                "id": "French Southern Territories",
                "label": "French Southern Territories"
            },
            {
                "id": "New Caledonia",
                "label": "New Caledonia"
            },
            {
                "id": "Burkina Faso",
                "label": "Burkina Faso"
            },
            {
                "id": "El Salvado",
                "label": "El Salvado"
            },
            {
                "id": "Slovakia",
                "label": "Slovakia"
            },
            {
                "id": "Azerbaijan",
                "label": "Azerbaijan"
            },
            {
                "id": "Panama",
                "label": "Panama"
            },
            {
                "id": "Cuba",
                "label": "Cuba"
            },
            {
                "id": "Togo",
                "label": "Togo"
            },
            {
                "id": "Bosnia and Herzegovina",
                "label": "Bosnia and Herzegovina"
            },
            {
                "id": "Estonia",
                "label": "Estonia"
            },
            {
                "id": "Guernsey",
                "label": "Guernsey"
            },
            {
                "id": "Jordan",
                "label": "Jordan"
            },
            {
                "id": "Andorra",
                "label": "Andorra"
            },
            {
                "id": "Libya",
                "label": "Libya"
            },
            {
                "id": "Nicaragua",
                "label": "Nicaragua"
            },
            {
                "id": "Barbados",
                "label": "Barbados"
            },
            {
                "id": "Aruba",
                "label": "Aruba"
            },
            {
                "id": "Bermuda",
                "label": "Bermuda"
            },
            {
                "id": "Uzbekistan",
                "label": "Uzbekistan"
            },
            {
                "id": "Cayman Islands",
                "label": "Cayman Islands"
            },
            {
                "id": "Dominican",
                "label": "Dominican"
            },
            {
                "id": "Oman",
                "label": "Oman"
            },
            {
                "id": "Ethiopia",
                "label": "Ethiopia"
            },
            {
                "id": "The Gambia",
                "label": "The Gambia"
            },
            {
                "id": "Rwanda",
                "label": "Rwanda"
            },
            {
                "id": "Mali",
                "label": "Mali"
            },
            {
                "id": "Zimbabwe",
                "label": "Zimbabwe"
            },
            {
                "id": "Zambia",
                "label": "Zambia"
            },
            {
                "id": "Afghanista",
                "label": "Afghanista"
            },
            {
                "id": "Saint Lucia",
                "label": "Saint Lucia"
            },
            {
                "id": "Cambodia",
                "label": "Cambodia"
            },
            {
                "id": "Botswana",
                "label": "Botswana"
            },
            {
                "id": "Montenegro",
                "label": "Montenegro"
            },
            {
                "id": "Iceland",
                "label": "Iceland"
            },
            {
                "id": "Puerto Rico",
                "label": "Puerto Rico"
            },
            {
                "id": "Venezuela",
                "label": "Venezuela"
            },
            {
                "id": "North Macedonia",
                "label": "North Macedonia"
            },
            {
                "id": "Haiti",
                "label": "Haiti"
            },
            {
                "id": "Macedonia",
                "label": "Macedonia"
            },
            {
                "id": "Cape Verde",
                "label": "Cape Verde"
            },
            {
                "id": "Burundi",
                "label": "Burundi"
            },
            {
                "id": "Paraguay",
                "label": "Paraguay"
            },
            {
                "id": "Faroe Islands",
                "label": "Faroe Islands"
            },
            {
                "id": "Brunei",
                "label": "Brunei"
            },
            {
                "id": "Angola",
                "label": "Angola"
            },
            {
                "id": "Grenada",
                "label": "Grenada"
            },
            {
                "id": "Belize",
                "label": "Belize"
            },
            {
                "id": "Fiji",
                "label": "Fiji"
            },
            {
                "id": "Mongolia",
                "label": "Mongolia"
            },
            {
                "id": "The Bahama",
                "label": "The Bahama"
            },
            {
                "id": "South Korea",
                "label": "South Korea"
            },
            {
                "id": "Mayotte",
                "label": "Mayotte"
            },
            {
                "id": "El Salvador",
                "label": "El Salvador"
            },
            {
                "id": "Dominican Republic",
                "label": "Dominican Republic"
            },
            {
                "id": "Georgia",
                "label": "Georgia"
            },
            {
                "id": "Macedonia (FYROM)",
                "label": "Macedonia (FYROM)"
            },
            {
                "id": "Swaziland",
                "label": "Swaziland"
            },
            {
                "id": "Gibraltar",
                "label": "Gibraltar"
            },
            {
                "id": "French Guiana",
                "label": "French Guiana"
            },
            {
                "id": "French Southern and Antarctic Lands",
                "label": "French Southern and Antarctic Lands"
            },
            {
                "id": "Isle of Man",
                "label": "Isle of Man"
            },
            {
                "id": "Namibia",
                "label": "Namibia"
            },
            {
                "id": "Sudan",
                "label": "Sudan"
            },
            {
                "id": "Falkland Islands (Islas Malvinas)",
                "label": "Falkland Islands (Islas Malvinas)"
            },
            {
                "id": "Guyana",
                "label": "Guyana"
            },
            {
                "id": "Afghanistan",
                "label": "Afghanistan"
            },
            {
                "id": "The Bahamas",
                "label": "The Bahamas"
            },
            {
                "id": "Honduras",
                "label": "Honduras"
            },
            {
                "id": "Tajikistan",
                "label": "Tajikistan"
            },
            {
                "id": "Jamaica",
                "label": "Jamaica"
            },
            {
                "id": "Nepal",
                "label": "Nepal"
            },
            {
                "id": "Malawi",
                "label": "Malawi"
            },
            {
                "id": "Somalia",
                "label": "Somalia"
            },
            {
                "id": "Central African Republic",
                "label": "Central African Republic"
            },
            {
                "id": "Republic of Indonesia",
                "label": "Republic of Indonesia"
            },
            {
                "id": "Mozambique",
                "label": "Mozambique"
            },
            {
                "id": "Bolivia",
                "label": "Bolivia"
            },
            {
                "id": "Palau",
                "label": "Palau"
            },
            {
                "id": "Republic of the Union of Myanmar",
                "label": "Republic of the Union of Myanmar"
            },
            {
                "id": "Democratic Republic of the Congo",
                "label": "Democratic Republic of the Congo"
            },
            {
                "id": "Trinidad and Tobago",
                "label": "Trinidad and Tobago"
            },
            {
                "id": "Russian Federation",
                "label": "Russian Federation"
            },
            {
                "id": "Eswatini",
                "label": "Eswatini"
            },
            {
                "id": "Laos",
                "label": "Laos"
            },
            {
                "id": "Republic of the Congo",
                "label": "Republic of the Congo"
            },
            {
                "id": "Armenia",
                "label": "Armenia"
            },
            {
                "id": "Liechtenstein",
                "label": "Liechtenstein"
            },
            {
                "id": "British Virgin Islands",
                "label": "British Virgin Islands"
            },
            {
                "id": "Antigua and Barbuda",
                "label": "Antigua and Barbuda"
            },
            {
                "id": "Maldives",
                "label": "Maldives"
            },
            {
                "id": "Comoros",
                "label": "Comoros"
            },
            {
                "id": "Macao",
                "label": "Macao"
            },
            {
                "id": "Papua New Guinea",
                "label": "Papua New Guinea"
            },
            {
                "id": "Myanmar (Burma)",
                "label": "Myanmar (Burma)"
            },
            {
                "id": "Yemen",
                "label": "Yemen"
            },
            {
                "id": "Dominica",
                "label": "Dominica"
            },
            {
                "id": "Liberia",
                "label": "Liberia"
            },
            {
                "id": "Sierra Leone",
                "label": "Sierra Leone"
            },
            {
                "id": "South Sudan",
                "label": "South Sudan"
            },
            {
                "id": "Åland Islands",
                "label": "Åland Islands"
            },
            {
                "id": "Saint Martin",
                "label": "Saint Martin"
            },
            {
                "id": "San Marino",
                "label": "San Marino"
            },
            {
                "id": "Turks and Caicos Islands",
                "label": "Turks and Caicos Islands"
            },
            {
                "id": "Saint Barthélemy",
                "label": "Saint Barthélemy"
            },
            {
                "id": "Saint Kitts and Nevis",
                "label": "Saint Kitts and Nevis"
            },
            {
                "id": "Kyrgyzstan",
                "label": "Kyrgyzstan"
            },
            {
                "id": "Seychelles",
                "label": "Seychelles"
            },
            {
                "id": "Vatican City",
                "label": "Vatican City"
            },
            {
                "id": "British Indian Ocean Territory",
                "label": "British Indian Ocean Territory"
            },
            {
                "id": "Timor-Leste",
                "label": "Timor-Leste"
            },
            {
                "id": "Anguilla",
                "label": "Anguilla"
            },
            {
                "id": "Antarctica",
                "label": "Antarctica"
            },
            {
                "id": "Equatorial Guinea",
                "label": "Equatorial Guinea"
            },
            {
                "id": "Curaçao",
                "label": "Curaçao"
            },
            {
                "id": "U.S. Virgin Islands",
                "label": "U.S. Virgin Islands"
            },
            {
                "id": "Samoa",
                "label": "Samoa"
            },
            {
                "id": "Svalbard and Jan Mayen",
                "label": "Svalbard and Jan Mayen"
            },
            {
                "id": "Guinea-Bissau",
                "label": "Guinea-Bissau"
            },
            {
                "id": "Bhutan",
                "label": "Bhutan"
            },
            {
                "id": "Macau",
                "label": "Macau"
            },
            {
                "id": "Saint-Barthélemy",
                "label": "Saint-Barthélemy"
            },
            {
                "id": "American Samoa",
                "label": "American Samoa"
            },
            {
                "id": "Lesotho",
                "label": "Lesotho"
            }
        ]

      // Devuelve una promesa que resuelve con el array simulado
      return new Promise((resolve, reject) => {
        resolve(countries);
      });
}

function getTimezones() {


    let timezones = [
    {
        "id": "118",
        "label": "Africa Abidjan ( GMT +00:00 )"
    },
    {
        "id": "167",
        "label": "Africa Accra ( GMT +00:00 )"
    },
    {
        "id": "152",
        "label": "Africa Addis_Ababa ( GMT +03:00 )"
    },
    {
        "id": "142",
        "label": "Africa Algiers ( GMT +01:00 )"
    },
    {
        "id": "148",
        "label": "Africa Asmara ( GMT +03:00 )"
    },
    {
        "id": "242",
        "label": "Africa Bamako ( GMT +00:00 )"
    },
    {
        "id": "115",
        "label": "Africa Bangui ( GMT +01:00 )"
    },
    {
        "id": "173",
        "label": "Africa Banjul ( GMT +00:00 )"
    },
    {
        "id": "181",
        "label": "Africa Bissau ( GMT +00:00 )"
    },
    {
        "id": "255",
        "label": "Africa Blantyre ( GMT +02:00 )"
    },
    {
        "id": "116",
        "label": "Africa Brazzaville ( GMT +01:00 )"
    },
    {
        "id": "56",
        "label": "Africa Bujumbura ( GMT +02:00 )"
    },
    {
        "id": "146",
        "label": "Africa Cairo ( GMT +02:00 )"
    },
    {
        "id": "233",
        "label": "Africa Casablanca ( GMT +00:00 )"
    },
    {
        "id": "149",
        "label": "Africa Ceuta ( GMT +01:00 )"
    },
    {
        "id": "174",
        "label": "Africa Conakry ( GMT +00:00 )"
    },
    {
        "id": "339",
        "label": "Africa Dakar ( GMT +00:00 )"
    },
    {
        "id": "363",
        "label": "Africa Dar_es_Salaam ( GMT +03:00 )"
    },
    {
        "id": "138",
        "label": "Africa Djibouti ( GMT +03:00 )"
    },
    {
        "id": "122",
        "label": "Africa Douala ( GMT +01:00 )"
    },
    {
        "id": "147",
        "label": "Africa El_Aaiun ( GMT +00:00 )"
    },
    {
        "id": "337",
        "label": "Africa Freetown ( GMT +00:00 )"
    },
    {
        "id": "81",
        "label": "Africa Gaborone ( GMT +02:00 )"
    },
    {
        "id": "418",
        "label": "Africa Harare ( GMT +02:00 )"
    },
    {
        "id": "416",
        "label": "Africa Johannesburg ( GMT +02:00 )"
    },
    {
        "id": "342",
        "label": "Africa Juba ( GMT +03:00 )"
    },
    {
        "id": "368",
        "label": "Africa Kampala ( GMT +03:00 )"
    },
    {
        "id": "330",
        "label": "Africa Khartoum ( GMT +03:00 )"
    },
    {
        "id": "326",
        "label": "Africa Kigali ( GMT +02:00 )"
    },
    {
        "id": "113",
        "label": "Africa Kinshasa ( GMT +01:00 )"
    },
    {
        "id": "275",
        "label": "Africa Lagos ( GMT +01:00 )"
    },
    {
        "id": "161",
        "label": "Africa Libreville ( GMT +01:00 )"
    },
    {
        "id": "351",
        "label": "Africa Lome ( GMT +00:00 )"
    },
    {
        "id": "8",
        "label": "Africa Luanda ( GMT +01:00 )"
    },
    {
        "id": "114",
        "label": "Africa Lubumbashi ( GMT +02:00 )"
    },
    {
        "id": "417",
        "label": "Africa Lusaka ( GMT +02:00 )"
    },
    {
        "id": "176",
        "label": "Africa Malabo ( GMT +01:00 )"
    },
    {
        "id": "270",
        "label": "Africa Maputo ( GMT +02:00 )"
    },
    {
        "id": "228",
        "label": "Africa Maseru ( GMT +02:00 )"
    },
    {
        "id": "347",
        "label": "Africa Mbabane ( GMT +02:00 )"
    },
    {
        "id": "340",
        "label": "Africa Mogadishu ( GMT +03:00 )"
    },
    {
        "id": "227",
        "label": "Africa Monrovia ( GMT +00:00 )"
    },
    {
        "id": "205",
        "label": "Africa Nairobi ( GMT +03:00 )"
    },
    {
        "id": "349",
        "label": "Africa Ndjamena ( GMT +01:00 )"
    },
    {
        "id": "273",
        "label": "Africa Niamey ( GMT +01:00 )"
    },
    {
        "id": "250",
        "label": "Africa Nouakchott ( GMT +00:00 )"
    },
    {
        "id": "53",
        "label": "Africa Ouagadougou ( GMT +00:00 )"
    },
    {
        "id": "57",
        "label": "Africa Porto-Novo ( GMT +01:00 )"
    },
    {
        "id": "343",
        "label": "Africa Sao_Tome ( GMT +00:00 )"
    },
    {
        "id": "232",
        "label": "Africa Tripoli ( GMT +02:00 )"
    },
    {
        "id": "357",
        "label": "Africa Tunis ( GMT +01:00 )"
    },
    {
        "id": "271",
        "label": "Africa Windhoek ( GMT +02:00 )"
    },
    {
        "id": "372",
        "label": "America Adak ( GMT -10:00 )"
    },
    {
        "id": "373",
        "label": "America Anchorage ( GMT -09:00 )"
    },
    {
        "id": "5",
        "label": "America Anguilla ( GMT -04:00 )"
    },
    {
        "id": "4",
        "label": "America Antigua ( GMT -04:00 )"
    },
    {
        "id": "63",
        "label": "America Araguaina ( GMT -03:00 )"
    },
    {
        "id": "19",
        "label": "America Argentina Buenos_Aires ( GMT -03:00 )"
    },
    {
        "id": "20",
        "label": "America Argentina Catamarca ( GMT -03:00 )"
    },
    {
        "id": "21",
        "label": "America Argentina Cordoba ( GMT -03:00 )"
    },
    {
        "id": "22",
        "label": "America Argentina Jujuy ( GMT -03:00 )"
    },
    {
        "id": "23",
        "label": "America Argentina La_Rioja ( GMT -03:00 )"
    },
    {
        "id": "24",
        "label": "America Argentina Mendoza ( GMT -03:00 )"
    },
    {
        "id": "25",
        "label": "America Argentina Rio_Gallegos ( GMT -03:00 )"
    },
    {
        "id": "26",
        "label": "America Argentina Salta ( GMT -03:00 )"
    },
    {
        "id": "27",
        "label": "America Argentina San_Juan ( GMT -03:00 )"
    },
    {
        "id": "28",
        "label": "America Argentina San_Luis ( GMT -03:00 )"
    },
    {
        "id": "29",
        "label": "America Argentina Tucuman ( GMT -03:00 )"
    },
    {
        "id": "30",
        "label": "America Argentina Ushuaia ( GMT -03:00 )"
    },
    {
        "id": "46",
        "label": "America Aruba ( GMT -04:00 )"
    },
    {
        "id": "303",
        "label": "America Asuncion ( GMT -03:00 )"
    },
    {
        "id": "84",
        "label": "America Atikokan ( GMT -05:00 )"
    },
    {
        "id": "64",
        "label": "America Bahia ( GMT -03:00 )"
    },
    {
        "id": "256",
        "label": "America Bahia_Banderas ( GMT -06:00 )"
    },
    {
        "id": "50",
        "label": "America Barbados ( GMT -04:00 )"
    },
    {
        "id": "65",
        "label": "America Belem ( GMT -03:00 )"
    },
    {
        "id": "83",
        "label": "America Belize ( GMT -06:00 )"
    },
    {
        "id": "85",
        "label": "America Blanc-Sablon ( GMT -04:00 )"
    },
    {
        "id": "66",
        "label": "America Boa_Vista ( GMT -04:00 )"
    },
    {
        "id": "128",
        "label": "America Bogota ( GMT -05:00 )"
    },
    {
        "id": "374",
        "label": "America Boise ( GMT -07:00 )"
    },
    {
        "id": "86",
        "label": "America Cambridge_Bay ( GMT -07:00 )"
    },
    {
        "id": "67",
        "label": "America Campo_Grande ( GMT -03:00 )"
    },
    {
        "id": "257",
        "label": "America Cancun ( GMT -06:00 )"
    },
    {
        "id": "407",
        "label": "America Caracas ( GMT -04:30 )"
    },
    {
        "id": "165",
        "label": "America Cayenne ( GMT -03:00 )"
    },
    {
        "id": "216",
        "label": "America Cayman ( GMT -05:00 )"
    },
    {
        "id": "375",
        "label": "America Chicago ( GMT -06:00 )"
    },
    {
        "id": "258",
        "label": "America Chihuahua ( GMT -07:00 )"
    },
    {
        "id": "129",
        "label": "America Costa_Rica ( GMT -06:00 )"
    },
    {
        "id": "87",
        "label": "America Creston ( GMT -07:00 )"
    },
    {
        "id": "68",
        "label": "America Cuiaba ( GMT -03:00 )"
    },
    {
        "id": "132",
        "label": "America Curacao ( GMT -04:00 )"
    },
    {
        "id": "169",
        "label": "America Danmarkshavn ( GMT +00:00 )"
    },
    {
        "id": "88",
        "label": "America Dawson ( GMT -08:00 )"
    },
    {
        "id": "89",
        "label": "America Dawson_Creek ( GMT -07:00 )"
    },
    {
        "id": "376",
        "label": "America Denver ( GMT -07:00 )"
    },
    {
        "id": "377",
        "label": "America Detroit ( GMT -05:00 )"
    },
    {
        "id": "140",
        "label": "America Dominica ( GMT -04:00 )"
    },
    {
        "id": "90",
        "label": "America Edmonton ( GMT -07:00 )"
    },
    {
        "id": "69",
        "label": "America Eirunepe ( GMT -05:00 )"
    },
    {
        "id": "344",
        "label": "America El_Salvador ( GMT -06:00 )"
    },
    {
        "id": "70",
        "label": "America Fortaleza ( GMT -03:00 )"
    },
    {
        "id": "91",
        "label": "America Glace_Bay ( GMT -04:00 )"
    },
    {
        "id": "170",
        "label": "America Godthab ( GMT -03:00 )"
    },
    {
        "id": "92",
        "label": "America Goose_Bay ( GMT -04:00 )"
    },
    {
        "id": "348",
        "label": "America Grand_Turk ( GMT -05:00 )"
    },
    {
        "id": "163",
        "label": "America Grenada ( GMT -04:00 )"
    },
    {
        "id": "175",
        "label": "America Guadeloupe ( GMT -04:00 )"
    },
    {
        "id": "179",
        "label": "America Guatemala ( GMT -06:00 )"
    },
    {
        "id": "143",
        "label": "America Guayaquil ( GMT -05:00 )"
    },
    {
        "id": "182",
        "label": "America Guyana ( GMT -04:00 )"
    },
    {
        "id": "93",
        "label": "America Halifax ( GMT -04:00 )"
    },
    {
        "id": "130",
        "label": "America Havana ( GMT -05:00 )"
    },
    {
        "id": "259",
        "label": "America Hermosillo ( GMT -07:00 )"
    },
    {
        "id": "378",
        "label": "America Indiana Indianapolis ( GMT -05:00 )"
    },
    {
        "id": "379",
        "label": "America Indiana Knox ( GMT -06:00 )"
    },
    {
        "id": "380",
        "label": "America Indiana Marengo ( GMT -05:00 )"
    },
    {
        "id": "381",
        "label": "America Indiana Petersburg ( GMT -05:00 )"
    },
    {
        "id": "382",
        "label": "America Indiana Tell_City ( GMT -06:00 )"
    },
    {
        "id": "383",
        "label": "America Indiana Vevay ( GMT -05:00 )"
    },
    {
        "id": "384",
        "label": "America Indiana Vincennes ( GMT -05:00 )"
    },
    {
        "id": "385",
        "label": "America Indiana Winamac ( GMT -05:00 )"
    },
    {
        "id": "94",
        "label": "America Inuvik ( GMT -07:00 )"
    },
    {
        "id": "95",
        "label": "America Iqaluit ( GMT -05:00 )"
    },
    {
        "id": "202",
        "label": "America Jamaica ( GMT -05:00 )"
    },
    {
        "id": "386",
        "label": "America Juneau ( GMT -09:00 )"
    },
    {
        "id": "387",
        "label": "America Kentucky Louisville ( GMT -05:00 )"
    },
    {
        "id": "388",
        "label": "America Kentucky Monticello ( GMT -05:00 )"
    },
    {
        "id": "62",
        "label": "America Kralendijk ( GMT -04:00 )"
    },
    {
        "id": "61",
        "label": "America La_Paz ( GMT -04:00 )"
    },
    {
        "id": "286",
        "label": "America Lima ( GMT -05:00 )"
    },
    {
        "id": "389",
        "label": "America Los_Angeles ( GMT -08:00 )"
    },
    {
        "id": "345",
        "label": "America Lower_Princes ( GMT -04:00 )"
    },
    {
        "id": "71",
        "label": "America Maceio ( GMT -03:00 )"
    },
    {
        "id": "276",
        "label": "America Managua ( GMT -06:00 )"
    },
    {
        "id": "72",
        "label": "America Manaus ( GMT -04:00 )"
    },
    {
        "id": "237",
        "label": "America Marigot ( GMT -04:00 )"
    },
    {
        "id": "249",
        "label": "America Martinique ( GMT -04:00 )"
    },
    {
        "id": "260",
        "label": "America Matamoros ( GMT -06:00 )"
    },
    {
        "id": "261",
        "label": "America Mazatlan ( GMT -07:00 )"
    },
    {
        "id": "390",
        "label": "America Menominee ( GMT -06:00 )"
    },
    {
        "id": "262",
        "label": "America Merida ( GMT -06:00 )"
    },
    {
        "id": "391",
        "label": "America Metlakatla ( GMT -08:00 )"
    },
    {
        "id": "263",
        "label": "America Mexico_City ( GMT -06:00 )"
    },
    {
        "id": "294",
        "label": "America Miquelon ( GMT -03:00 )"
    },
    {
        "id": "96",
        "label": "America Moncton ( GMT -04:00 )"
    },
    {
        "id": "264",
        "label": "America Monterrey ( GMT -06:00 )"
    },
    {
        "id": "402",
        "label": "America Montevideo ( GMT -02:00 )"
    },
    {
        "id": "97",
        "label": "America Montreal ( GMT -05:00 )"
    },
    {
        "id": "251",
        "label": "America Montserrat ( GMT -04:00 )"
    },
    {
        "id": "79",
        "label": "America Nassau ( GMT -05:00 )"
    },
    {
        "id": "392",
        "label": "America New_York ( GMT -05:00 )"
    },
    {
        "id": "98",
        "label": "America Nipigon ( GMT -05:00 )"
    },
    {
        "id": "393",
        "label": "America Nome ( GMT -09:00 )"
    },
    {
        "id": "73",
        "label": "America Noronha ( GMT -02:00 )"
    },
    {
        "id": "394",
        "label": "America North_Dakota Beulah ( GMT -06:00 )"
    },
    {
        "id": "395",
        "label": "America North_Dakota Center ( GMT -06:00 )"
    },
    {
        "id": "396",
        "label": "America North_Dakota New_Salem ( GMT -06:00 )"
    },
    {
        "id": "265",
        "label": "America Ojinaga ( GMT -07:00 )"
    },
    {
        "id": "285",
        "label": "America Panama ( GMT -05:00 )"
    },
    {
        "id": "99",
        "label": "America Pangnirtung ( GMT -05:00 )"
    },
    {
        "id": "341",
        "label": "America Paramaribo ( GMT -03:00 )"
    },
    {
        "id": "397",
        "label": "America Phoenix ( GMT -07:00 )"
    },
    {
        "id": "186",
        "label": "America Port-au-Prince ( GMT -05:00 )"
    },
    {
        "id": "74",
        "label": "America Porto_Velho ( GMT -04:00 )"
    },
    {
        "id": "360",
        "label": "America Port_of_Spain ( GMT -04:00 )"
    },
    {
        "id": "296",
        "label": "America Puerto_Rico ( GMT -04:00 )"
    },
    {
        "id": "100",
        "label": "America Rainy_River ( GMT -06:00 )"
    },
    {
        "id": "101",
        "label": "America Rankin_Inlet ( GMT -06:00 )"
    },
    {
        "id": "75",
        "label": "America Recife ( GMT -03:00 )"
    },
    {
        "id": "102",
        "label": "America Regina ( GMT -06:00 )"
    },
    {
        "id": "103",
        "label": "America Resolute ( GMT -06:00 )"
    },
    {
        "id": "76",
        "label": "America Rio_Branco ( GMT -05:00 )"
    },
    {
        "id": "77",
        "label": "America Santarem ( GMT -03:00 )"
    },
    {
        "id": "266",
        "label": "America Santa_Isabel ( GMT -08:00 )"
    },
    {
        "id": "120",
        "label": "America Santiago ( GMT -03:00 )"
    },
    {
        "id": "141",
        "label": "America Santo_Domingo ( GMT -04:00 )"
    },
    {
        "id": "78",
        "label": "America Sao_Paulo ( GMT -02:00 )"
    },
    {
        "id": "171",
        "label": "America Scoresbysund ( GMT -01:00 )"
    },
    {
        "id": "398",
        "label": "America Shiprock ( GMT -07:00 )"
    },
    {
        "id": "399",
        "label": "America Sitka ( GMT -09:00 )"
    },
    {
        "id": "58",
        "label": "America St_Barthelemy ( GMT -04:00 )"
    },
    {
        "id": "104",
        "label": "America St_Johns ( GMT -03:30 )"
    },
    {
        "id": "212",
        "label": "America St_Kitts ( GMT -04:00 )"
    },
    {
        "id": "224",
        "label": "America St_Lucia ( GMT -04:00 )"
    },
    {
        "id": "409",
        "label": "America St_Thomas ( GMT -04:00 )"
    },
    {
        "id": "406",
        "label": "America St_Vincent ( GMT -04:00 )"
    },
    {
        "id": "105",
        "label": "America Swift_Current ( GMT -06:00 )"
    },
    {
        "id": "184",
        "label": "America Tegucigalpa ( GMT -06:00 )"
    },
    {
        "id": "172",
        "label": "America Thule ( GMT -04:00 )"
    },
    {
        "id": "106",
        "label": "America Thunder_Bay ( GMT -05:00 )"
    },
    {
        "id": "267",
        "label": "America Tijuana ( GMT -08:00 )"
    },
    {
        "id": "107",
        "label": "America Toronto ( GMT -05:00 )"
    },
    {
        "id": "408",
        "label": "America Tortola ( GMT -04:00 )"
    },
    {
        "id": "108",
        "label": "America Vancouver ( GMT -08:00 )"
    },
    {
        "id": "109",
        "label": "America Whitehorse ( GMT -08:00 )"
    },
    {
        "id": "110",
        "label": "America Winnipeg ( GMT -06:00 )"
    },
    {
        "id": "400",
        "label": "America Yakutat ( GMT -09:00 )"
    },
    {
        "id": "111",
        "label": "America Yellowknife ( GMT -07:00 )"
    },
    {
        "id": "9",
        "label": "Antarctica Casey ( GMT +08:00 )"
    },
    {
        "id": "10",
        "label": "Antarctica Davis ( GMT +07:00 )"
    },
    {
        "id": "11",
        "label": "Antarctica DumontDUrville ( GMT +10:00 )"
    },
    {
        "id": "33",
        "label": "Antarctica Macquarie ( GMT +11:00 )"
    },
    {
        "id": "12",
        "label": "Antarctica Mawson ( GMT +05:00 )"
    },
    {
        "id": "13",
        "label": "Antarctica McMurdo ( GMT +13:00 )"
    },
    {
        "id": "14",
        "label": "Antarctica Palmer ( GMT -03:00 )"
    },
    {
        "id": "15",
        "label": "Antarctica Rothera ( GMT -03:00 )"
    },
    {
        "id": "16",
        "label": "Antarctica South_Pole ( GMT +13:00 )"
    },
    {
        "id": "17",
        "label": "Antarctica Syowa ( GMT +03:00 )"
    },
    {
        "id": "18",
        "label": "Antarctica Vostok ( GMT +06:00 )"
    },
    {
        "id": "335",
        "label": "Arctic Longyearbyen ( GMT +01:00 )"
    },
    {
        "id": "414",
        "label": "Asia Aden ( GMT +03:00 )"
    },
    {
        "id": "217",
        "label": "Asia Almaty ( GMT +06:00 )"
    },
    {
        "id": "203",
        "label": "Asia Amman ( GMT +02:00 )"
    },
    {
        "id": "308",
        "label": "Asia Anadyr ( GMT +12:00 )"
    },
    {
        "id": "218",
        "label": "Asia Aqtau ( GMT +05:00 )"
    },
    {
        "id": "219",
        "label": "Asia Aqtobe ( GMT +05:00 )"
    },
    {
        "id": "356",
        "label": "Asia Ashgabat ( GMT +05:00 )"
    },
    {
        "id": "197",
        "label": "Asia Baghdad ( GMT +03:00 )"
    },
    {
        "id": "55",
        "label": "Asia Bahrain ( GMT +03:00 )"
    },
    {
        "id": "48",
        "label": "Asia Baku ( GMT +04:00 )"
    },
    {
        "id": "352",
        "label": "Asia Bangkok ( GMT +07:00 )"
    },
    {
        "id": "223",
        "label": "Asia Beirut ( GMT +02:00 )"
    },
    {
        "id": "206",
        "label": "Asia Bishkek ( GMT +06:00 )"
    },
    {
        "id": "60",
        "label": "Asia Brunei ( GMT +08:00 )"
    },
    {
        "id": "244",
        "label": "Asia Choibalsan ( GMT +08:00 )"
    },
    {
        "id": "123",
        "label": "Asia Chongqing ( GMT +08:00 )"
    },
    {
        "id": "226",
        "label": "Asia Colombo ( GMT +05:30 )"
    },
    {
        "id": "346",
        "label": "Asia Damascus ( GMT +02:00 )"
    },
    {
        "id": "51",
        "label": "Asia Dhaka ( GMT +06:00 )"
    },
    {
        "id": "355",
        "label": "Asia Dili ( GMT +09:00 )"
    },
    {
        "id": "2",
        "label": "Asia Dubai ( GMT +04:00 )"
    },
    {
        "id": "353",
        "label": "Asia Dushanbe ( GMT +05:00 )"
    },
    {
        "id": "297",
        "label": "Asia Gaza ( GMT +02:00 )"
    },
    {
        "id": "124",
        "label": "Asia Harbin ( GMT +08:00 )"
    },
    {
        "id": "298",
        "label": "Asia Hebron ( GMT +02:00 )"
    },
    {
        "id": "183",
        "label": "Asia Hong_Kong ( GMT +08:00 )"
    },
    {
        "id": "245",
        "label": "Asia Hovd ( GMT +07:00 )"
    },
    {
        "id": "410",
        "label": "Asia Ho_Chi_Minh ( GMT +07:00 )"
    },
    {
        "id": "309",
        "label": "Asia Irkutsk ( GMT +09:00 )"
    },
    {
        "id": "188",
        "label": "Asia Jakarta ( GMT +07:00 )"
    },
    {
        "id": "189",
        "label": "Asia Jayapura ( GMT +09:00 )"
    },
    {
        "id": "193",
        "label": "Asia Jerusalem ( GMT +02:00 )"
    },
    {
        "id": "3",
        "label": "Asia Kabul ( GMT +04:30 )"
    },
    {
        "id": "310",
        "label": "Asia Kamchatka ( GMT +12:00 )"
    },
    {
        "id": "292",
        "label": "Asia Karachi ( GMT +05:00 )"
    },
    {
        "id": "125",
        "label": "Asia Kashgar ( GMT +08:00 )"
    },
    {
        "id": "279",
        "label": "Asia Kathmandu ( GMT +05:45 )"
    },
    {
        "id": "311",
        "label": "Asia Khandyga ( GMT +10:00 )"
    },
    {
        "id": "195",
        "label": "Asia Kolkata ( GMT +05:30 )"
    },
    {
        "id": "312",
        "label": "Asia Krasnoyarsk ( GMT +08:00 )"
    },
    {
        "id": "268",
        "label": "Asia Kuala_Lumpur ( GMT +08:00 )"
    },
    {
        "id": "269",
        "label": "Asia Kuching ( GMT +08:00 )"
    },
    {
        "id": "215",
        "label": "Asia Kuwait ( GMT +03:00 )"
    },
    {
        "id": "247",
        "label": "Asia Macau ( GMT +08:00 )"
    },
    {
        "id": "313",
        "label": "Asia Magadan ( GMT +12:00 )"
    },
    {
        "id": "190",
        "label": "Asia Makassar ( GMT +08:00 )"
    },
    {
        "id": "291",
        "label": "Asia Manila ( GMT +08:00 )"
    },
    {
        "id": "284",
        "label": "Asia Muscat ( GMT +04:00 )"
    },
    {
        "id": "134",
        "label": "Asia Nicosia ( GMT +02:00 )"
    },
    {
        "id": "314",
        "label": "Asia Novokuznetsk ( GMT +07:00 )"
    },
    {
        "id": "315",
        "label": "Asia Novosibirsk ( GMT +07:00 )"
    },
    {
        "id": "316",
        "label": "Asia Omsk ( GMT +07:00 )"
    },
    {
        "id": "220",
        "label": "Asia Oral ( GMT +05:00 )"
    },
    {
        "id": "207",
        "label": "Asia Phnom_Penh ( GMT +07:00 )"
    },
    {
        "id": "191",
        "label": "Asia Pontianak ( GMT +07:00 )"
    },
    {
        "id": "213",
        "label": "Asia Pyongyang ( GMT +09:00 )"
    },
    {
        "id": "304",
        "label": "Asia Qatar ( GMT +03:00 )"
    },
    {
        "id": "221",
        "label": "Asia Qyzylorda ( GMT +06:00 )"
    },
    {
        "id": "243",
        "label": "Asia Rangoon ( GMT +06:30 )"
    },
    {
        "id": "327",
        "label": "Asia Riyadh ( GMT +03:00 )"
    },
    {
        "id": "317",
        "label": "Asia Sakhalin ( GMT +11:00 )"
    },
    {
        "id": "403",
        "label": "Asia Samarkand ( GMT +05:00 )"
    },
    {
        "id": "214",
        "label": "Asia Seoul ( GMT +09:00 )"
    },
    {
        "id": "126",
        "label": "Asia Shanghai ( GMT +08:00 )"
    },
    {
        "id": "332",
        "label": "Asia Singapore ( GMT +08:00 )"
    },
    {
        "id": "362",
        "label": "Asia Taipei ( GMT +08:00 )"
    },
    {
        "id": "404",
        "label": "Asia Tashkent ( GMT +05:00 )"
    },
    {
        "id": "164",
        "label": "Asia Tbilisi ( GMT +04:00 )"
    },
    {
        "id": "198",
        "label": "Asia Tehran ( GMT +03:30 )"
    },
    {
        "id": "80",
        "label": "Asia Thimphu ( GMT +06:00 )"
    },
    {
        "id": "204",
        "label": "Asia Tokyo ( GMT +09:00 )"
    },
    {
        "id": "246",
        "label": "Asia Ulaanbaatar ( GMT +08:00 )"
    },
    {
        "id": "127",
        "label": "Asia Urumqi ( GMT +08:00 )"
    },
    {
        "id": "318",
        "label": "Asia Ust-Nera ( GMT +11:00 )"
    },
    {
        "id": "222",
        "label": "Asia Vientiane ( GMT +07:00 )"
    },
    {
        "id": "319",
        "label": "Asia Vladivostok ( GMT +11:00 )"
    },
    {
        "id": "320",
        "label": "Asia Yakutsk ( GMT +10:00 )"
    },
    {
        "id": "321",
        "label": "Asia Yekaterinburg ( GMT +06:00 )"
    },
    {
        "id": "7",
        "label": "Asia Yerevan ( GMT +04:00 )"
    },
    {
        "id": "299",
        "label": "Atlantic Azores ( GMT -01:00 )"
    },
    {
        "id": "59",
        "label": "Atlantic Bermuda ( GMT -04:00 )"
    },
    {
        "id": "150",
        "label": "Atlantic Canary ( GMT +00:00 )"
    },
    {
        "id": "131",
        "label": "Atlantic Cape_Verde ( GMT -01:00 )"
    },
    {
        "id": "159",
        "label": "Atlantic Faroe ( GMT +00:00 )"
    },
    {
        "id": "300",
        "label": "Atlantic Madeira ( GMT +00:00 )"
    },
    {
        "id": "199",
        "label": "Atlantic Reykjavik ( GMT +00:00 )"
    },
    {
        "id": "178",
        "label": "Atlantic South_Georgia ( GMT -02:00 )"
    },
    {
        "id": "155",
        "label": "Atlantic Stanley ( GMT -03:00 )"
    },
    {
        "id": "333",
        "label": "Atlantic St_Helena ( GMT +00:00 )"
    },
    {
        "id": "34",
        "label": "Australia Adelaide ( GMT +10:30 )"
    },
    {
        "id": "35",
        "label": "Australia Brisbane ( GMT +10:00 )"
    },
    {
        "id": "36",
        "label": "Australia Broken_Hill ( GMT +10:30 )"
    },
    {
        "id": "37",
        "label": "Australia Currie ( GMT +11:00 )"
    },
    {
        "id": "38",
        "label": "Australia Darwin ( GMT +09:30 )"
    },
    {
        "id": "39",
        "label": "Australia Eucla ( GMT +08.45 )"
    },
    {
        "id": "40",
        "label": "Australia Hobart ( GMT +11:00 )"
    },
    {
        "id": "41",
        "label": "Australia Lindeman ( GMT +10:00 )"
    },
    {
        "id": "42",
        "label": "Australia Lord_Howe ( GMT +11:00 )"
    },
    {
        "id": "43",
        "label": "Australia Melbourne ( GMT +11:00 )"
    },
    {
        "id": "44",
        "label": "Australia Perth ( GMT +08:00 )"
    },
    {
        "id": "45",
        "label": "Australia Sydney ( GMT +11:00 )"
    },
    {
        "id": "277",
        "label": "Europe Amsterdam ( GMT +01:00 )"
    },
    {
        "id": "1",
        "label": "Europe Andorra ( GMT +01:00 )"
    },
    {
        "id": "177",
        "label": "Europe Athens ( GMT +02:00 )"
    },
    {
        "id": "307",
        "label": "Europe Belgrade ( GMT +01:00 )"
    },
    {
        "id": "136",
        "label": "Europe Berlin ( GMT +01:00 )"
    },
    {
        "id": "336",
        "label": "Europe Bratislava ( GMT +01:00 )"
    },
    {
        "id": "52",
        "label": "Europe Brussels ( GMT +01:00 )"
    },
    {
        "id": "306",
        "label": "Europe Bucharest ( GMT +02:00 )"
    },
    {
        "id": "187",
        "label": "Europe Budapest ( GMT +01:00 )"
    },
    {
        "id": "137",
        "label": "Europe Busingen ( GMT +01:00 )"
    },
    {
        "id": "235",
        "label": "Europe Chisinau ( GMT +02:00 )"
    },
    {
        "id": "139",
        "label": "Europe Copenhagen ( GMT +01:00 )"
    },
    {
        "id": "192",
        "label": "Europe Dublin ( GMT +00:00 )"
    },
    {
        "id": "168",
        "label": "Europe Gibraltar ( GMT +01:00 )"
    },
    {
        "id": "166",
        "label": "Europe Guernsey ( GMT +00:00 )"
    },
    {
        "id": "153",
        "label": "Europe Helsinki ( GMT +02:00 )"
    },
    {
        "id": "194",
        "label": "Europe Isle_of_Man ( GMT +00:00 )"
    },
    {
        "id": "359",
        "label": "Europe Istanbul ( GMT +02:00 )"
    },
    {
        "id": "201",
        "label": "Europe Jersey ( GMT +00:00 )"
    },
    {
        "id": "322",
        "label": "Europe Kaliningrad ( GMT +03:00 )"
    },
    {
        "id": "364",
        "label": "Europe Kiev ( GMT +02:00 )"
    },
    {
        "id": "301",
        "label": "Europe Lisbon ( GMT +00:00 )"
    },
    {
        "id": "334",
        "label": "Europe Ljubljana ( GMT +01:00 )"
    },
    {
        "id": "162",
        "label": "Europe London ( GMT +00:00 )"
    },
    {
        "id": "230",
        "label": "Europe Luxembourg ( GMT +01:00 )"
    },
    {
        "id": "151",
        "label": "Europe Madrid ( GMT +01:00 )"
    },
    {
        "id": "252",
        "label": "Europe Malta ( GMT +01:00 )"
    },
    {
        "id": "47",
        "label": "Europe Mariehamn ( GMT +02:00 )"
    },
    {
        "id": "82",
        "label": "Europe Minsk ( GMT +03:00 )"
    },
    {
        "id": "234",
        "label": "Europe Monaco ( GMT +01:00 )"
    },
    {
        "id": "323",
        "label": "Europe Moscow ( GMT +04:00 )"
    },
    {
        "id": "278",
        "label": "Europe Oslo ( GMT +01:00 )"
    },
    {
        "id": "160",
        "label": "Europe Paris ( GMT +01:00 )"
    },
    {
        "id": "236",
        "label": "Europe Podgorica ( GMT +01:00 )"
    },
    {
        "id": "135",
        "label": "Europe Prague ( GMT +01:00 )"
    },
    {
        "id": "231",
        "label": "Europe Riga ( GMT +02:00 )"
    },
    {
        "id": "200",
        "label": "Europe Rome ( GMT +01:00 )"
    },
    {
        "id": "324",
        "label": "Europe Samara ( GMT +04:00 )"
    },
    {
        "id": "338",
        "label": "Europe San_Marino ( GMT +01:00 )"
    },
    {
        "id": "49",
        "label": "Europe Sarajevo ( GMT +01:00 )"
    },
    {
        "id": "365",
        "label": "Europe Simferopol ( GMT +02:00 )"
    },
    {
        "id": "241",
        "label": "Europe Skopje ( GMT +01:00 )"
    },
    {
        "id": "54",
        "label": "Europe Sofia ( GMT +02:00 )"
    },
    {
        "id": "331",
        "label": "Europe Stockholm ( GMT +01:00 )"
    },
    {
        "id": "145",
        "label": "Europe Tallinn ( GMT +02:00 )"
    },
    {
        "id": "6",
        "label": "Europe Tirane ( GMT +01:00 )"
    },
    {
        "id": "366",
        "label": "Europe Uzhgorod ( GMT +02:00 )"
    },
    {
        "id": "225",
        "label": "Europe Vaduz ( GMT +01:00 )"
    },
    {
        "id": "405",
        "label": "Europe Vatican ( GMT +01:00 )"
    },
    {
        "id": "32",
        "label": "Europe Vienna ( GMT +01:00 )"
    },
    {
        "id": "229",
        "label": "Europe Vilnius ( GMT +02:00 )"
    },
    {
        "id": "325",
        "label": "Europe Volgograd ( GMT +04:00 )"
    },
    {
        "id": "293",
        "label": "Europe Warsaw ( GMT +01:00 )"
    },
    {
        "id": "185",
        "label": "Europe Zagreb ( GMT +01:00 )"
    },
    {
        "id": "367",
        "label": "Europe Zaporozhye ( GMT +02:00 )"
    },
    {
        "id": "117",
        "label": "Europe Zurich ( GMT +01:00 )"
    },
    {
        "id": "238",
        "label": "Indian Antananarivo ( GMT +03:00 )"
    },
    {
        "id": "196",
        "label": "Indian Chagos ( GMT +06:00 )"
    },
    {
        "id": "133",
        "label": "Indian Christmas ( GMT +07:00 )"
    },
    {
        "id": "112",
        "label": "Indian Cocos ( GMT +06:30 )"
    },
    {
        "id": "211",
        "label": "Indian Comoro ( GMT +03:00 )"
    },
    {
        "id": "350",
        "label": "Indian Kerguelen ( GMT +05:00 )"
    },
    {
        "id": "329",
        "label": "Indian Mahe ( GMT +04:00 )"
    },
    {
        "id": "254",
        "label": "Indian Maldives ( GMT +05:00 )"
    },
    {
        "id": "253",
        "label": "Indian Mauritius ( GMT +04:00 )"
    },
    {
        "id": "415",
        "label": "Indian Mayotte ( GMT +03:00 )"
    },
    {
        "id": "305",
        "label": "Indian Reunion ( GMT +04:00 )"
    },
    {
        "id": "413",
        "label": "Pacific Apia ( GMT +14:00 )"
    },
    {
        "id": "282",
        "label": "Pacific Auckland ( GMT +13:00 )"
    },
    {
        "id": "283",
        "label": "Pacific Chatham ( GMT 12.45 )"
    },
    {
        "id": "156",
        "label": "Pacific Chuuk ( GMT +10:00 )"
    },
    {
        "id": "121",
        "label": "Pacific Easter ( GMT -05:00 )"
    },
    {
        "id": "411",
        "label": "Pacific Efate ( GMT +11:00 )"
    },
    {
        "id": "208",
        "label": "Pacific Enderbury ( GMT +13:00 )"
    },
    {
        "id": "354",
        "label": "Pacific Fakaofo ( GMT +13:00 )"
    },
    {
        "id": "154",
        "label": "Pacific Fiji ( GMT +13:00 )"
    },
    {
        "id": "361",
        "label": "Pacific Funafuti ( GMT +12:00 )"
    },
    {
        "id": "144",
        "label": "Pacific Galapagos ( GMT -06:00 )"
    },
    {
        "id": "287",
        "label": "Pacific Gambier ( GMT -09:00 )"
    },
    {
        "id": "328",
        "label": "Pacific Guadalcanal ( GMT +11:00 )"
    },
    {
        "id": "180",
        "label": "Pacific Guam ( GMT +10:00 )"
    },
    {
        "id": "401",
        "label": "Pacific Honolulu ( GMT -10:00 )"
    },
    {
        "id": "369",
        "label": "Pacific Johnston ( GMT -10:00 )"
    },
    {
        "id": "209",
        "label": "Pacific Kiritimati ( GMT +14:00 )"
    },
    {
        "id": "157",
        "label": "Pacific Kosrae ( GMT +11:00 )"
    },
    {
        "id": "239",
        "label": "Pacific Kwajalein ( GMT +12:00 )"
    },
    {
        "id": "240",
        "label": "Pacific Majuro ( GMT +12:00 )"
    },
    {
        "id": "288",
        "label": "Pacific Marquesas ( GMT -09:30 )"
    },
    {
        "id": "370",
        "label": "Pacific Midway ( GMT -11:00 )"
    },
    {
        "id": "280",
        "label": "Pacific Nauru ( GMT +12:00 )"
    },
    {
        "id": "281",
        "label": "Pacific Niue ( GMT -11:00 )"
    },
    {
        "id": "274",
        "label": "Pacific Norfolk ( GMT +11:30 )"
    },
    {
        "id": "272",
        "label": "Pacific Noumea ( GMT +11:00 )"
    },
    {
        "id": "31",
        "label": "Pacific Pago_Pago ( GMT -11:00 )"
    },
    {
        "id": "302",
        "label": "Pacific Palau ( GMT +09:00 )"
    },
    {
        "id": "295",
        "label": "Pacific Pitcairn ( GMT -08:00 )"
    },
    {
        "id": "158",
        "label": "Pacific Pohnpei ( GMT +11:00 )"
    },
    {
        "id": "290",
        "label": "Pacific Port_Moresby ( GMT +10:00 )"
    },
    {
        "id": "119",
        "label": "Pacific Rarotonga ( GMT -10:00 )"
    },
    {
        "id": "248",
        "label": "Pacific Saipan ( GMT +10:00 )"
    },
    {
        "id": "289",
        "label": "Pacific Tahiti ( GMT -10:00 )"
    },
    {
        "id": "210",
        "label": "Pacific Tarawa ( GMT +12:00 )"
    },
    {
        "id": "358",
        "label": "Pacific Tongatapu ( GMT +13:00 )"
    },
    {
        "id": "371",
        "label": "Pacific Wake ( GMT +12:00 )"
    },
    {
        "id": "412",
        "label": "Pacific Wallis ( GMT +12:00 )"
    }
    ]

      // Devuelve una promesa que resuelve con el array simulado
      return new Promise((resolve, reject) => {
        resolve(timezones);
      });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
